/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { parseDate } from "utils/Utils";
import goldRatesStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import TableContainer from "@material-ui/core/TableContainer";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { PDFExport } from "@progress/kendo-react-pdf";
import AcknowledgementPayment from "views/admin/components/Acknowledgementpayment/AcknowledgementPayment";
import FileUploadDisbursal from "components/FileUpload/FileUploadDisbursal";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ConfirmationModal from "views/admin/components/ConfirmationModal";
import DisbursalSendBack from "./DisbursalSendBack";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import OtpModal from "../OtpModal/OtpModal";
import {
  Grid,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";
import ToastModal from "views/components/ToastModal";
import { useNavigate, useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { LOAN_STATUS_CLOSED } from "assets/properties/properties";
import { restructureArrayFunc } from "utils/Utils";
import { validateDisbursalAmount } from "utils/Utils";
import { getDateOnly } from "utils/Utils";
import { removeSpecialCharFileName } from "utils/Utils";
import { disbursalScreenTableColumns } from "assets/properties/properties";
import { headerLabel } from "assets/properties/properties";
import CustomDateField from "components/CustomDateSelector/CustomDateField";
import { repledgeCaseListName } from "assets/properties/properties";
import { sanitizeLoanAccountNumber } from "utils/Utils";
import { formatAmount } from "utils/Utils";
const useStyles = makeStyles(tableStyle);
const useStylesTable = makeStyles(tableStyle);
const DisbursalRePledge = ({
  setNext,
  setBack,
  loanApplicationId,
  loanApplicationNumbedisbusalDetails,
  setDisbursalLoan,
  status,
  closeModal,
  customerProceedId,
  loanAccountNumber,
  prePledgeLoan,
  initiatorType,
  userDetails,
  applicantDetails,
  yearlyCashValue,
  financialYearCashValidationFlag,
  removeMaturityvalidation,
  seletedBranchCode,
  leadBranchCode,
  featureFlags,
  subStatus,
  cashAmountPerLoanDisbursalTime,
  premiumDetails,
  actualLoanAmount,
  prepledgeLoanMap,
  prepledgeLoanData,
  prePledgeDisbursalDate
}) => {
  const classes = useStyles();
   const classTable = useStylesTable();
  let fileUploadComponent = useRef();
  const pdfExportComponent = React.useRef(null);
  const [schemeCharge, setSchemeCharge] = useState([]);
  const [schemeCalculateCharges, setSchemeCalculateCharges] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [logo, setLogo] = useState("");
  const [isbankDetailsAvaliable, setIsBankDetailsAvaliable] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [paymentReferenceNumber, setPaymentReferenceNumber] = useState("");
  const [fileUpload, setFileUpload] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [loanamount, setLoanamount] = useState("");
  const [applicationLoanId, setLoanAppilcationId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [fileName, setFileName] = useState("");
  const [msg, setMsg] = useState("");
  const [head, setHead] = useState("");
  const [show, setShow] = useState(false);
  const [calculatenetPayAble, setCalculatenetPayable] = useState("");
  const [cash, setCash] = useState(0);
  const [bankAmount, setBankAmount] = useState("");
  const [disbursalCharges, setDisbursalCharges] = useState([]);
  const [lastIndex, setLastIndex] = useState(0);
  const [disbursalDates, setDisbursalDates] = useState(subStatus === "POST_PLEDGE" ? prePledgeDisbursalDate : new Date());
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [addButtonEnabled, setAddButtonEnabled] = useState(true);
  const [processignFeePerentage, setProcessignFeePerentage] = useState('');
    const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoverName, setHoverName] = useState("");
  const handleClose = () => {
    setShowModal(!showModal);
  };
  const outletData = featureFlags;
  const enabledMultiLoanAdjsutmentTopUp=  typeof outletData?.enabledMultiLoanAdjsutmentTopUp !== "undefined" ?  JSON.parse(outletData?.enabledMultiLoanAdjsutmentTopUp) : []
  const enableMultiLoan = enabledMultiLoanAdjsutmentTopUp?.includes(subStatus)
  const enableColletralValidation = parseAndSetFlag(outletData.enableColletralOperationValidation);
  const disableCashField = parseAndSetFlag(outletData.disableCashFieldDisbursal)
  const enablePersonalLoanCheck = parseAndSetFlag(outletData?.enablePersonalLoanCheck);
  const maxROIFlag = parseAndSetFlag(outletData.maxRoiFeatureFlag)
  const enabledMinMAxPercentageFieldsCharges = parseAndSetFlag(outletData?.enabledMinMAxPercentageFieldsCharges);
  const enabledPacketChangeInRenewalModal = parseAndSetFlag(outletData?.enabledPacketChangeInRenewalModal);
  const ignoreListSubstatusData = JSON.parse(outletData?.ignoreCollateralValuationCheck);
  const closureTimePayableAdjust = parseAndSetFlag(outletData?.closureTimePayableAdjust);
  const closureTimeExceedAmount = parseAndSetFlag(outletData?.closureTimeExceedAmount);
  const sameDayLoanProcessingFees = parseAndSetFlag(outletData?.sameDayLoanProcessingFees);
  const PANCRITERIA = Number(yearlyCashValue);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const navigate = useNavigate();

  useEffect(() => {
    GetAccountDetails();
    GetLogoLink();
  }, []);
useEffect(()=>{
  if(subStatus !== repledgeCaseListName?.partRelease){
    const mismatchLoans = prepledgeLoanData?.filter(item => String(item?.customerId) !== String(customerProceedId)).map(item => item?.loanAccountNumber);
    const dataSet = new Set(prepledgeLoanData?.map(item => sanitizeLoanAccountNumber(item?.loanAccountNumber, featureFlags?.convertLoanAccountMunber)));
    const missingLoans = Object.keys(prepledgeLoanMap)?.filter( key => !dataSet.has(key));
    if (missingLoans?.length > 0 || prepledgeLoanData === 0) {
        toastUpdate("Error", `Adjusted Loan Account Number ${missingLoans?.join(', ')} are closed`, true);
        setDisableSubmit(true)
    }else if(mismatchLoans?.length > 0){
        setDisableSubmit(true)
        toastUpdate("Error", `Customer mismatch for Loan Account Number ${mismatchLoans?.join(', ')}`, true);
    }else{
      setDisableSubmit(false)
    }
  }
},[prepledgeLoanData, prepledgeLoanMap])
  const GetLogoLink = async () => {
    const result = await apiHandler({
      url: endpoint.LOGO_URL,
      method: "GET",
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setLogo(result?.data?.logo);
    }
    if(enabledPacketChangeInRenewalModal && subStatus !== repledgeCaseListName?.partRelease){
      await getOrnamentDetails();
    }
  };
  const getOrnamentDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if(result?.data?.error_code){
      toastUpdate("Error", result?.data?.user_description, true);
    }else{
      if(result?.data?.ornamentDetails?.length > 0){
        setAddButtonEnabled(!result?.data?.ornamentDetails?.[0]?.existingOrnament)
      }
    }
  }
  const GenerateReceiptNumber = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.RECEIPT_NUMBER + "?branchCode=" + leadBranchCode,
      authToken: authToken,
      method: "POST",
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);

    } else {
      await setPaymentReferenceNumber(result?.data?.ReceiptNum);
      onGenerate();
    }
  };
  const addData = () => {
    if (cash > 0 && isbankDetailsAvaliable) {
      toastUpdate("Information", "If you want to adjust with loan then please remove the cash", true);

    } else {
      addNextRow();
    }
  };
  const checkPersonalLoanLink = async (loanAccountNumber) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.CHECK_PERSONAL_LOAN_DATA + sanitizeLoanAccountNumber(loanAccountNumber, featureFlags?.convertLoanAccountMunber),
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result.data.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);

    } else {
      if(result?.data === "" || !result?.data?.externalLoanExist || (result?.data?.externalLoanExist && result?.data?.loanStatus === LOAN_STATUS_CLOSED)){
        setDisableSubmit(false);
        return true;
      }else{
      toastUpdate("Error",`Linked Personal loan ${result?.data?.loanAccountNumber} is not closed`, true);
      setDisableSubmit(true);
      return false;
      }
    }
  };
   //Check Collateral Movement
   const checkCollateralMovement = async (loanNumber) => {
    if (enablePersonalLoanCheck) {
        const isPersonalLoanOk = await checkPersonalLoanLink(loanNumber);
        if (!isPersonalLoanOk) return false;
    }
    setCallInProgress(true);
    const result = await apiHandler({
      url:
        endpoint.COLLATERAL_NEXT_MOVEMENT + sanitizeLoanAccountNumber(loanNumber, featureFlags?.convertLoanAccountMunber),
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);

    } else {
      const nextMovements = result?.data?.nextMovements || [];
      const checkMovement = nextMovements.includes("SEND_TO_HO");
      if(enableColletralValidation){
      if(enabledPacketChangeInRenewalModal && ignoreListSubstatusData?.includes(subStatus)){
        setDisableSubmit(false);
        return true
      }else if(checkMovement){
        setDisableSubmit(false);
        return true;
      }else{
        toastUpdate("Error","Packet is not in branch. Please do Collateral Movement", true);
        setDisableSubmit(true);
        return false;
      }
    }else{
      return true
    }
  }
};
  const GetLoanClosureDuesDetails = async (value, array, loanValue, isBank, firstTime) => {
    const targetValue = value?.trim();
    if (targetValue === "") return;
    const isCollateralMovementOk = await checkCollateralMovement(targetValue);
    if(isCollateralMovementOk){
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.FIND_MAX_ROI_INTEREST_DATE + sanitizeLoanAccountNumber(targetValue, featureFlags?.convertLoanAccountMunber),
        authToken: authToken,
      });
      setCallInProgress(false);
    if (result?.data?.error_code  || result?.data?.error_description) {
      toastUpdate("Error", result?.data?.user_description, true);

    } else {
        const chargeArray = array ? array : disbursalCharges;
        const loanFinalAmount = loanValue ? loanValue : loanamount;
        const bankAvaliable = isBank ? isBank : isbankDetailsAvaliable;
        GetLoanClosureDuesDetail(chargeArray , loanFinalAmount, bankAvaliable, result?.data?.interestTillDate,targetValue,firstTime,result?.data?.maxRoi);
    }
  }
  };
  
  const addNextRow = () => {
    setDisableSubmit(true);
    let newIndex = disbursalCharges.length;
    setLastIndex(lastIndex + 1);
    let newArr = [...disbursalCharges]; // copying the old datas array
    newArr[newIndex] = {
      adjustedAmount: "",
      adjustedLoanAccountNumber: "",
      adjustment: "YES",
      chargeType: "",
      transactionRef: "",
      paymentMode: "CASH",
    };
    setDisbursalCharges(newArr);
    if (isbankDetailsAvaliable) {
      setCash(0);
      setBankAmount(calculatenetPayAble);
    }
  };
  const onClickDeleteData = async () => {
    setDisableSubmit(false)
    if (cash > 0 && isbankDetailsAvaliable) {
      toastUpdate("Information", "If you want to adjust with loan then please remove the cash", true);

    } else {
      // setStatus("");
      // setCheckId(true);
      setLastIndex(lastIndex - 1);
      const newSchemeArry = disbursalCharges.splice(
        0, disbursalCharges?.length - 1
      );
      setDisbursalCharges(newSchemeArry);
      onCalculatePayable(newSchemeArry, loanamount, isbankDetailsAvaliable);
    }
  };

  const handleDateChange = (date) => {
    setDisbursalDates(date);
  };

  const GetAccountDetails = async () => {
    setCallInProgress(true);
    //BANKINFORMATION_GETDATA
    const result = await apiHandler({
      url:
        endpoint.BANKINFORMATION_GETDATA +
        "?" +
        "applicationId=" +
        loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code === 404) {
      setIsBankDetailsAvaliable(false);
      GetDisbursalCharges(false);
    }else if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);

    } else {
      await setIsBankDetailsAvaliable(result?.data?.accountNumber !== null);
      GetDisbursalCharges(result?.data?.accountNumber !== null);
    }
  };

  // getting the charges
  const GetDisbursalCharges = async (isBankAvailable, percentageValue, skipCashChargeApi) => {
    setCallInProgress(true);
    const requestOptions = {
      url: endpoint.DISBURSAL_SCHEME_CHARGES + loanApplicationId,
      authToken: authToken,
      method: "POST",
    };
    requestOptions.data = {};

    if (enabledMinMAxPercentageFieldsCharges && Number(percentageValue) >= 0) {
      const processingFee = Number(percentageValue) > 0 ? percentageValue : 0;
      requestOptions.data.processingFeePercentage = processingFee;
    }

    if (sameDayLoanProcessingFees && Number(actualLoanAmount) > 0 && Object.entries(prepledgeLoanMap)?.length === 1) {
      requestOptions.data.loanAmountForProcessFee = actualLoanAmount;
    }

    const res = await apiHandler(requestOptions);
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      setLoanamount(res?.data?.actualLoanAmount);
      setSchemeCharge(res?.data?.schemeCalculations);
      let trailBalancesMapped = (percentageValue !== undefined && percentageValue !== null)
      ? [...disbursalCharges]
      : [];
      if (percentageValue !== undefined && percentageValue !== null) {
        const processingFeeObj = res?.data?.schemeCalculations?.find(
           (item) => item.adjustment === "PROCESSING_FEE"
         );
        if (processingFeeObj) {
          trailBalancesMapped = trailBalancesMapped.map((item) => {
            if (item.adjustment === "PROCESSING_FEE") {
              return {
                ...item,
                ...processingFeeObj,
                adjustedLoanAccountNumber: "",
                transactionRef: "",
                paymentMode: isbankDetailsAvaliable ? "BANK" : "CASH"
              };
            }
            return item;
          });
        }
      }else{
      for (let i = 0; i < res?.data?.schemeCalculations?.length; i++) {
        const curObj = res?.data?.schemeCalculations[i];
        const newObj = {};
        Object.keys(curObj).forEach((key) => {
          if (key) {
            newObj[`${key}`] = curObj[key];
          }
          if (key === "adjustment") {
            newObj[`${"adjustedLoanAccountNumber"}`] = "";
            newObj[`${"transactionRef"}`] = "";
            newObj[`${"paymentMode"}`] = isbankDetailsAvaliable
              ? "BANK"
              : "CASH";
          }
        });
        trailBalancesMapped.push(newObj);
      }
      }
      if(enabledMinMAxPercentageFieldsCharges){
        setDisbursalCharges(trailBalancesMapped);
      }
      if (!isBankAvailable && skipCashChargeApi !== "skipCashChargeApi") {
        GetDisbursalCashCharges(
          trailBalancesMapped,
          isBankAvailable,
          res?.data?.actualLoanAmount,
          percentageValue
        );
      } else {
        
        if(skipCashChargeApi === "skipCashChargeApi"){
           onCalculatePayable(trailBalancesMapped, res?.data?.actualLoanAmount, isBankAvailable);
        }else{
        if(subStatus !== repledgeCaseListName?.partRelease){
          const newEntries = prepledgeLoanData.map((item)=>({
            adjustedAmount: Number(item?.netClosureAmt) - Number(item.interestWaiveOffAmt) - (closureTimePayableAdjust ? Number(item?.payableAmount) : 0) + (closureTimeExceedAmount ? Number(item?.excessInterestAmount) : 0),
            adjustedLoanAccountNumber: sanitizeLoanAccountNumber(item?.loanAccountNumber, featureFlags?.convertLoanAccountMunber),
            adjustment: "YES",
            chargeType: "",
            transactionRef: "",
            paymentMode: "CASH",
          }));
          const newArr = [...trailBalancesMapped, ...newEntries];
          await onCalculatePayable(newArr, res?.data?.actualLoanAmount, isBankAvailable );
          setDisbursalCharges(newArr);
          setLastIndex(prepledgeLoanData?.length -1)
        }else{
          GetLoanClosureDuesDetails(prePledgeLoan, trailBalancesMapped, res?.data?.actualLoanAmount,isBankAvailable , "firstTime")
        }
        }
      }
    }
  };

  const GetLoanClosureDuesDetail = async (array, cashValue, isBank, currentDate, loanAccountNumber, firstTime, maxROIInterest) => {
    setCallInProgress(true);
//BANKINFORMATION_GETDATA
    const result = await apiHandler({
      url:
        endpoint.LOAN_CLOSURE_DUES +
        "?penaltyRate=0&waveOff=0&refund=0&interestTillDate=" +
        currentDate +
        "&" +
        "loanAccountNumber=" +
        loanAccountNumber + "&maxRoi=" + maxROIInterest,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);

    } else {
      const maturityDate = new Date(result?.data?.maturityDate);
      if (!isNaN(maturityDate) && getDateOnly(maturityDate) < getDateOnly(new Date()) && !removeMaturityvalidation) {
        toastUpdate("Error", `Adjusted account number ${loanAccountNumber} is matured`, true);
        setAddButtonEnabled(false)
        setDisableSubmit(true);
        return;
      }
      if (result?.data?.loanStatus?.toLowerCase() === "closed") {
        setDisableSubmit(true);
          setAddButtonEnabled(false)
        toastUpdate("Error", `Adjusted account number ${loanAccountNumber} is closed`, true);
        return;
      }
      if (result?.data?.customerId !== customerProceedId) {
        setDisableSubmit(true);
          setAddButtonEnabled(false)
        toastUpdate("Error",`Adjusted loan account ${loanAccountNumber} customer id is not same`, true);
        return;
      }
      setDisableSubmit(false);
      // setAdjustmentAmount(result?.data?.totalDues);
      let newArr = [...array]; // copying the old datas array
      let newIndex = firstTime ?  array.length : array.length -1;
      const adjustedLoanAmount = Number(result?.data?.totalDues) - Number(result?.data?.interestWaiveOffAmt) - (closureTimePayableAdjust ? Number(result?.data?.payableAmount) : 0) + (closureTimeExceedAmount ? Number(result?.data?.excessInterestAmount) : 0);
      newArr[newIndex] = {
        adjustedAmount: adjustedLoanAmount,
        adjustedLoanAccountNumber: loanAccountNumber,
        adjustment: "YES",
        chargeType: "",
        transactionRef: "",
        paymentMode: "CASH",
      };
      await onCalculatePayable(newArr, cashValue, isBank);
      setDisbursalCharges(newArr);
    }
  };
  // Getting the cash charges
  const GetDisbursalCashCharges = async (
    chargeDetails,
    isBank,
    cashValue,
    validateCashValue
  ) => {
    const chargeDetailsValue = validateCashValue
    ? disbursalCharges
    : chargeDetails;
    setCallInProgress(true);
    const res = await apiHandler({
      url:
        endpoint.DISBURSAL_CASH_CHARGES +
        loanApplicationId +
        "?cashAmount=" +
        cashValue,
      authToken: authToken,
      method: "POST",
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);

    } else {
      let trailBalancesMapped = [];
      for (let i = 0; i < res?.data?.schemeCalculations?.length; i++) {
        const curObj = res?.data?.schemeCalculations[i];
        const newObj = {};
        Object.keys(curObj).forEach((key) => {
          if (key) {
            newObj[`${key}`] = curObj[key];
          }
          if (key === "adjustment") {
            newObj[`${"adjustedLoanAccountNumber"}`] = "";
            newObj[`${"transactionRef"}`] = "";
            newObj[`${"paymentMode"}`] = "CASH";
          }
        });
        trailBalancesMapped.push(newObj);
      }
      const disbursalChargesArray = chargeDetailsValue.filter(
        (item) => item.chargeType !== "CASH_DISBURSAL"
      );
      const array = [...disbursalChargesArray, ...trailBalancesMapped];
      setDisbursalCharges(array);
     if(!isBank){
      setSchemeCharge(array)
     } 
      setSchemeCalculateCharges(array);
      const cashValueFinal = validateCashValue ? loanamount : cashValue;
      if (!isBank) {
        if( subStatus !== repledgeCaseListName?.partRelease){
        const newEntries = prepledgeLoanData.map((item)=>({
          adjustedAmount: Number(item?.netClosureAmt) - Number(item.interestWaiveOffAmt) - (closureTimePayableAdjust ? Number(item?.payableAmount) : 0) + (closureTimeExceedAmount ? Number(item?.excessInterestAmount) : 0),
          adjustedLoanAccountNumber: sanitizeLoanAccountNumber(item?.loanAccountNumber, featureFlags?.convertLoanAccountMunber),
          adjustment: "YES",
          chargeType: "",
          transactionRef: "",
          paymentMode: "CASH",
        }));

        const newArr = validateCashValue === "ValidateCash" ? array : [...array, ...newEntries];
        await onCalculatePayable(newArr, cashValueFinal, isBank);
        setDisbursalCharges(newArr);
        setLastIndex(prepledgeLoanData?.length -1)
      }else{
        GetLoanClosureDuesDetails(prePledgeLoan, array, cashValueFinal, isBank, "firstTime");
        await onCalculatePayable(array, cashValueFinal, isBank);
      }
      }else{
        onCalculatePayable(array, cashValueFinal, isBank);
      }
    }
  };

  const handleChange = (event, index) => {
    const checkDuplicateAccountNumber = disbursalCharges?.some(
      (block) => block?.adjustedLoanAccountNumber === event.target.value
    );
    const errorMessage = `Loan number ${event.target.value} already under adjustment`;
    if (
      checkDuplicateAccountNumber &&
      event.target.name === "adjustedLoanAccountNumber"
    ) {
      setDisableSubmit(true)
      toastUpdate("Error", errorMessage, true);
      return
    }

    const name = event.target.name;
    let value = event.target.value;
    let newArray = [...disbursalCharges];
    let itemList = newArray[disbursalCharges?.length - 1];
    if (name === "adjustedLoanAccountNumber") {
      itemList = { ...itemList, adjustedLoanAccountNumber: value?.trim() };
    }
    if(name === "Processing Fee")
    {
      const regexValue = /^\d*\.?\d{0,2}$/.test(value);
      if(regexValue || value === ""){
        setProcessignFeePerentage(value)
      }
    }
    newArray[disbursalCharges?.length - 1] = itemList;
    setDisbursalCharges(newArray);

    if (name === "cash") {
      setCash(Number(value));
    }
  };
  //DISBURESAL_CALCULATENETPAYABLE
  const onCalculatePayable = async (
    chargeDetails,
    loanAmount,
    isBank,
    cashChargeFlag,
    percentageValue,
  ) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.DISBURESAL_CALCULATENETPAYABLE,
      method: "POST",
      authToken: authToken,
      data: {
        loanAmount: loanAmount,
        adjustedLoans: chargeDetails,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);

      return;
    } else {
       const netPaybaleAmount = Number(res?.data?.netPayable) - Number(premiumDetails?.totalPremium || 0);
      setCalculatenetPayable(netPaybaleAmount);
      if (isBank) {
        setBankAmount(netPaybaleAmount);
      } else {
        setCash(netPaybaleAmount);
      }
    }
  };
  const validateSave = () => {
    if (cash < 0 || bankAmount < 0 || (bankAmount - cash < 0 && isbankDetailsAvaliable)) {
      toastUpdate("Error","None of Cash or Bank Amount will be in negative", true);
      return false;
    }
    if (Number(cash) > PANCRITERIA) {
      if(PANCRITERIA < 0){
        toastUpdate("Error",`This customer id already exceed cash limit`, true);
        return false;
      }
      toastUpdate("Error",`Cash Amount will not exceed ${PANCRITERIA}`, true);
      return false;
    }
    return true;
  };
  const validateProcessingFeePercentage = (e, data) => {
    const value = Number(e.target.value); // get numeric value from input
    const processingFeeMinPercentage = Number(data?.processingFeeMinPercentage ?? 0);
    const processingFeeMaxPercentage = Number(data?.processingFeeMaxPercentage ?? 100);

    if (value < processingFeeMinPercentage || value > processingFeeMaxPercentage) {
      toastUpdate(
        "Error",
        `Processing percentage must be between ${processingFeeMinPercentage} and ${processingFeeMaxPercentage}`,
        true
      );
      return;
    } else {
      GetDisbursalCharges(isbankDetailsAvaliable, value, "skipCashChargeApi");
    }
  };
  const validateCash = (e) => {
    if(bankAmount < 0 || cash < 0 || (bankAmount - cash < 0 && isbankDetailsAvaliable)){
      toastUpdate("Error", "None of Cash or Bank Amount will be in negative", true);
      setDisableSubmit(true)
      return false;
    }
    if (
      Number(bankAmount - cash < 0 ? cash : bankAmount) >
      Number(calculatenetPayAble)
    ) {
      toastUpdate("Error", "Total Cash and Bank Amount should be less than Net Amount Payable", true);

      setDisableSubmit(true)
      return false;
    }
    if (Number(cash) > PANCRITERIA) {
      toastUpdate("Error", `Cash Amount not exceed then ${PANCRITERIA}`, true);
      setDisableSubmit(true)
      return false;
    } else {
      GetDisbursalCashCharges(
        disbursalCharges,
        isbankDetailsAvaliable,
        e.target.value,
        "ValidateCash"
      );
      setDisableSubmit(false)
    }
  };
  const validateData = (data) => {
    let hasAdjustmentYes = false;
    let cashPayable = 0;
    let bankPayable = 0;

    for (const item of data) {
      // Check for "adjustment": "YES"
      if (item.adjustment === 'YES') {
        hasAdjustmentYes = true;
        if (item.adjustedAmount === '' || typeof item.adjustedAmount === 'undefined'  || item.adjustedAmount === null) {
          toastUpdate('Error','Error: adjustedAmount cannot be null or Empty when adjustment is YES.',true);
          return false;
        }
      }

      // Check paymentMode for CASH and BANK and accumulate netPayable
      if (item.paymentMode === 'CASH' && item.netPayable) {
        cashPayable += item.netPayable;
      }
      if (item.paymentMode === 'BANK' && item.netPayable) {
        bankPayable += item.netPayable;
      }
    }

    // If no "adjustment": "YES", then check netPayable for CASH and BANK
    if (!hasAdjustmentYes) {
      if (cashPayable <= 0 && bankPayable <= 0) {
        toastUpdate('Error','Error: netPayable cannot be zero for either CASH or BANK.',true);
        return false;
      }
    }

    return true
  };
  const payNowData = async (fileName) => {
    if (cash > 0 && fileUpload === "") {
      setCallInProgress(false);
      toastUpdate("Error", "Please upload cash acknowledgment", true);

      return false;
    }
    // setCallInProgress(true);
    let arr = [];
    if (cash > 0 && isbankDetailsAvaliable) {
      arr.push({
        disbursalAmount: loanamount,
        netPayable: cash,
        paymentMode: "CASH",
         cashReceiptLink:fileName,
      });
    }
    if (!isbankDetailsAvaliable) {
      arr.push({
        disbursalAmount: loanamount,
        netPayable: cash,
        paymentMode: "CASH",
         cashReceiptLink:fileName,
      });
    }
    if (bankAmount > 0 && isbankDetailsAvaliable) {
      arr.push({
        disbursalAmount: loanamount,
        netPayable: bankAmount - cash,
        paymentMode: "BANK",
      });
    }
    if(cash === 0 && bankAmount === 0){
      arr.push({
        disbursalAmount: loanamount,
        netPayable: cash,
        paymentMode: "CASH",
      });
    }
    disbursalCharges.forEach((grp, index) => {
      arr.push(grp);
    });
    const restructureArray = restructureArrayFunc(arr);
     if(!validateDisbursalAmount(restructureArray, premiumDetails?.totalPremium || 0)){
      toastUpdate("Error", "Adjusted amount and netpayable amount is not equal to disbursal amount", true)
        return 
    }
    if(validateData(restructureArray)){
    const res = await apiHandler({
      url: endpoint.DISBURSAL_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        disbursalDate: parseDate(disbursalDates),
        applicationDisbursalDetailDtos: restructureArray,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);

      return;
    } else {
      setLoanAppilcationId(res?.data?.id);
      if(!res?.data?.skipOtp){
        setShowModal(true);
      }else{
        toastUpdate("Success", res?.data?.message, true);
            navigate("/loanservice/disbursal", { state: { from: '' } });
      }
    }
  }
  };
  const onBack = () => {
    setBack();
  };
  const onNext = () => {
    setNext();
  };

  // delete function
  const onClickData = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setConfirmationModalHeader("Generate Cash Acknowledgement");
    setConfirmationModalMsg(
      "After receipt, you will not be able to change your CASH amount. Do you want to continue ?"
    );
    // setDeletePincodeId(pincode);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    //setDeleteUserId("");
  };
  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    GenerateReceiptNumber();
  };
  const onGenerate = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };
  const onUpload = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (validateSave()) {
      setCallInProgress(true);
      if (fileUpload) {
        const formData = new FormData();
        const fileName = removeSpecialCharFileName(fileUpload.name)
        formData.append("file", fileUpload, fileName);
        const result = await apiHandler({
          url: endpoint.FILE_UPLOAD,
          method: "POST",
          authToken: authToken,
          data: formData,
        });
        const uploadedPath = result.data;
        setFileName(uploadedPath?.name);
        payNowData(uploadedPath?.name);
      } else {
        payNowData("");
      }
      setCallInProgress(false);
    }
  };
  const resendOtp = async () => {
    const otpResponse = await apiHandler({
      url: endpoint.DISBURSAL_RESEND_OTP + applicationLoanId,
      method: "PUT",
      authToken: authToken,
    });
    if (otpResponse?.data?.error_code) {
      toastUpdate("Error", "Please fill the correct Details", true);

      return;
    } else {
      setMsg("OTP Sent Successfully");
      setHead("Information");
      setShow(true);
    }
  };

  const validateOtp = async (code) => {
    const result = await apiHandler({
      url: endpoint.DISBURSAL_VALIDATE_OTP,
      method: "POST",
      authToken: authToken,
      data: {
        id: applicationLoanId,
        otp: code,
      },
    });
    if (result?.data?.error_code) {
      toastUpdate("Error",'Kindly verify the otp or resend the otp', true);
    } else {
      setShowModal(false);
      toastUpdate("Success", result?.data?.message, true);
        navigate("/loanservice/disbursal", { state: { from: '' } });
    }
  };
  const indexLength = schemeCharge?.length + 1;

 
    const cashDisbursalField = disbursalCharges.filter(
    (item) => item.adjustment === "CASH_DISBURSAL"
  );
  const bankAmountFiled = cash <= 0 ? bankAmount : bankAmount - cash;
  const alreadyAdjustedAmount = disbursalCharges.filter((item)=> item?.adjustedLoanAccountNumber)

    const paymentAcknowledgeBranchName = leadBranchCode
  ? userDetails?.branches?.find(item => item.branchCode === leadBranchCode)?.branchName
  : userDetails?.branchName;
  const handleMouseEnter = (index, name) => {
    setHoveredIndex(index);
    setHoverName(name);
  };
  const handleMouseLeave = () => {
    setHoveredIndex(null); // Resets the hoveredIndex to null when mouse leaves any input
  };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
           <SubHeader
                       label={headerLabel?.disbursal}
                      subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                       onlyLabel/>
        </Grid>
      </Grid>
      {status === "DISBURSAL" && (
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={3}
            lg={3}
            style={{ textAlign: "start" }}
          >
            <CustomInput
              labelText="Loan Account Number"
              id="loan_account_number"
              formControlProps={{
                fullWidth: true,
                style: { marginTop: 0 },
              }}
              inputProps={{
                name: "loan Account Number",
                disabled: true,
                value: loanAccountNumber,
              }}
            />
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={3}
            lg={3}
            style={{ textAlign: "start" }}
          >
            <CustomInput
              labelText="Customer Id"
              id="customer_id"
              formControlProps={{
                fullWidth: true,
                style: { marginTop: 0 },
              }}
              inputProps={{
                name: "customer Id",
                disabled: true,
                value: customerProceedId,
              }}
            />
          </GridItem>
          <GridItem xs={10} sm={10} md={4} lg={4}></GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={4}
            lg={4}
            style={{ textAlign: "start" }}
          >
            <CustomDateField
              onChange={handleDateChange}
              value={disbursalDates ? disbursalDates : null}
              label="Disbursal Date"
              disabled= {paymentReferenceNumber || subStatus === "POST_PLEDGE"}
            />
          </GridItem>
        </GridContainer>
      )}
      <TableContainer className={classes.tableContianer}>
       <Table
          stickyHeader
          style={{
            minWidth: window.innerWidth < 600 ? "250%" : "100%",
          }}
        >
          <TableHead>
            <TableRow className={classes.tableHeadRowDisbursal}>
              {disbursalScreenTableColumns.map((item, i) => (
                <TableCell
                  key={i}
                  padding="checkbox"
                  className={classes.disbursalPostPledge}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow className={classes.tableBodyRowDisbursal}>
              <TableCell className={classes.disbursalPostPledges}>
                {
                  <CustomInput
                     id="amount"
                    formControlProps={{
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "disbursal_amount",
                      disabled: true,
                      value: formatAmount(loanamount),
                      onChange: (event) => {
                        handleChange(event);
                      },
                    }}
                  />
                }
              </TableCell>
              <TableCell className={classes.disbursalPostPledges}>
                {schemeCharge?.map(
                  (item, index) =>
                    (item?.adjustment && item?.chargeType) && (
                      <CustomInput
                        id="adjustment_charge"
                        key={index}
                        formControlProps={{
                          fullWidth: true,
                          style: { marginTop: 0 },
                        }}
                        inputProps={{
                          name: "adjustment",
                          disabled: true,
                          value: item?.adjustment,
                        }}
                      />
                    )
                )}
                  {Number(premiumDetails?.totalPremium) > 0 && (
                  <>
                    <CustomInput
                      id={`adjustment_insurance`}
                      formControlProps={{
                        fullWidth: true,
                        style: { marginTop: 0 },
                      }}
                      inputProps={{
                        name: "adjustment",
                        disabled: true,
                        value: "INSURANCE_PREMIUM",
                      }}
                    />
                  </>
                )}
                {cashDisbursalField.length > 0 &&  isbankDetailsAvaliable&& (
                  <CustomInput
                  id="adjustment"
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "adjustment",
                      disabled: true,
                      value: cashDisbursalField?.[0]?.adjustment,
                    }}
                  />
                )}
              </TableCell>
              <TableCell className={classes.disbursalPostPledges}>
                {schemeCharge?.map((item, index) => (
                  <React.Fragment key={index}>
                    <div style={{display:'flex'}}>
                    {item?.adjustment === "PROCESSING_FEE" &&
                      enabledMinMAxPercentageFieldsCharges &&
                      Number(item?.processingFeeMaxPercentage) > 0 && (
                      <div className={classTable.parentContainer}>
                      <CustomInput
                        id={`processing_fee${index + 1}`}
                        formControlProps={{
                          fullWidth: true,
                          style: { margin: '0 5px 0 0', maxWidth:'100px' },
                        }}
                        onMouseEnter={() => handleMouseEnter(index, "count")}
                        onMouseLeave={() => handleMouseLeave(index, "count")}
                        inputProps={{
                          name: "Processing Fee",
                          onBlur: (e) => validateProcessingFeePercentage(e,item),
                          value: processignFeePerentage,
                          onChange: (event) => {
                            handleChange(event, index);
                        },
                        }}
                      />
                      {hoveredIndex === index &&
                        hoverName === "count" &&
                        (item?.processingFeeMaxPercentage != null || item?.processingFeeMinPercentage != null) && (
                          <div className={classTable.countValue}>
                            <span>{`min ${item?.processingFeeMinPercentage}`}</span>
                            <span>{`max ${
                              item?.processingFeeMaxPercentage
                            }`}</span>
                          </div>
                        )}
                      </div>
                    )}
                    {(item?.adjustedAmount && item?.chargeType) &&
                      <CustomInput
                          id={`charge_amount${index + 1}`}
                          formControlProps={{
                            // fullWidth: true,
                          style: { marginTop: 0, maxWidth:'100px' },
                        }}
                        inputProps={{
                          name: "Charge Amount",
                          disabled: true,
                          value: Math.round(item?.adjustedAmount),
                        }}
                      />
                    }
                  </div>
                </React.Fragment>
                ))}
                         {Number(premiumDetails?.totalPremium) > 0 && (
                  <CustomInput
                    id={`charge_amount_insurance`}
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0, maxWidth: "100px" },
                    }}
                    inputProps={{
                      name: "Charge Amount",
                      disabled: true,
                      value: Number(premiumDetails?.totalPremium),
                    }}
                  />
                )}   
                {cashDisbursalField.length > 0 && isbankDetailsAvaliable && (
                  <CustomInput
                    id="adjustment_account"
                    formControlProps={{
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "adjustment",
                      disabled: true,
                      value: cashDisbursalField?.[0]?.adjustedAmount,
                    }}
                  />
                )}
              </TableCell>
              <TableCell className={classes.disbursalPostPledges}>
                {
                  <CustomInput
                    id="net_payable"
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "netPayable",
                      value: calculatenetPayAble,
                      disabled: true,
                      onChange: (event) => {
                        handleChange(event);
                      },
                    }}
                  />
                }
              </TableCell>
              <TableCell className={classes.disbursalPostPledges}>
                {
                  <CustomInput
                    id="cash"
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: "12px" },
                    }}
                    inputProps={{
                      name: "cash",
                      type: "number",
                      classes: { input: classes.inputStyle },
                      disabled: (disableSubmit || (!isbankDetailsAvaliable || (calculatenetPayAble > 0 && loanamount > PANCRITERIA && disableCashField))),
                      onBlur: (e) => validateCash(e),
                      value: cash,
                      onChange: (event) => {
                        handleChange(event);
                      },
                    }}
                  />
                }
              </TableCell>
              <TableCell className={classes.disbursalPostPledges}>
                {
                  <CustomInput
                  id="bank"
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "bank",
                      type: "number",
                      value: isbankDetailsAvaliable
                        ? bankAmountFiled
                        : bankAmount,
                      disabled: true,
                    }}
                  />
                }
              </TableCell>
            </TableRow>
            <TableRow className={classes.tableBodyRowDisbursal}>
              <TableCell
                className={classes.disbursalPostPledges}
                style={{ width: "16%" }}
              >
                {
                  <CustomInput
                    formControlProps={{
                      style: { marginTop: "12px" },
                    }}
                    id="adjustment_yes"
                    inputProps={{
                      name: "Adjustment",
                      classes: { input: classes.inputStyle },
                      disabled: true,
                      value: "YES",
                      onChange: (event) => {
                        handleChange(event);
                      },
                    }}
                  />
                }
              </TableCell>
              <TableCell className={classes.disbursalPostPledges}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      style: {
                        marginTop: 0,
                      },
                    }}
                    id="adjustment_account_number"
                    inputProps={{
                      name: "adjustedLoanAccountNumber",
                      disabled: true,
                      value: alreadyAdjustedAmount[0]?.adjustedLoanAccountNumber || prePledgeLoan,
                    }}
                  />

              </TableCell>
              <TableCell className={classes.disbursalPostPledges} >
              <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      style: {
                        marginTop: 0,
                      },
                    }}
                    id="adjustment_amount"
                    inputProps={{
                      name: "adjustedAmount",
                      disabled: true,
                      value: alreadyAdjustedAmount[0]?.adjustedAmount,
                    }}
                  />
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                      {lastIndex === 0 && status === "DISBURSAL" && addButtonEnabled && !enableMultiLoan && (
                              <AddIcon
                                onClick={() => addData()}
                                style={{
                                  color: "green",
                                  cursor: "pointer",
                                  marginTop: 20,
                                }}
                              />
                              )}
                        </TableCell>
            </TableRow>
            {Array.apply(null, { length: lastIndex }).map((e, i) => (
              <>
                <TableRow className={classes.tableBodyRowDisbursal}>
                <TableCell
                      className={classes.tableCellData}
                      style={{ width: "16%" }}
                    >
                        {
                        <CustomInput
                          formControlProps={{
                            style: {
                              marginTop: "12px",
                            },
                          }}
                          id="adjustment_yes"
                          inputProps={{
                            name: "adjustment",
                            classes: { input: classes.inputStyle },
                            disabled: true,
                            value: "YES",
                            onChange: (event) => {
                            handleChange(event);
                            },
                          }}
                        />
                      }
                    </TableCell>
                    <TableCell className={classes.disbursalPostPledges}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      style: {
                        marginTop: 0,
                      },
                    }}
                    id="adjustment_account_number"
                    inputProps={{
                      name: "adjustedLoanAccountNumber",
                      disabled: enableMultiLoan,
                      value:
                      disbursalCharges?.[
                      indexLength + i 
                      ]?.adjustedLoanAccountNumber?.trim(),
                      onBlur: (e) =>
                      GetLoanClosureDuesDetails(e.target.value),

                    onChange: (event) => {
                      handleChange(event, i);
                    },
                    }}
                  />

              </TableCell>
              <TableCell className={classes.disbursalPostPledges} >
              <CustomInput
                            id={`adjustedAmount${i + 1}`}
                            formControlProps={{
                              fullWidth: true,
                              style: {
                                marginTop: 0,
                              },
                            }}
                            inputProps={{
                              disabled: true,
                              name: "adjustedAmount",
                              type: "number",
                              value:
                              disbursalCharges?.[indexLength + i]
                                  ?.adjustedAmount,
                              onChange: (event) => {
                                handleChange(event, i);
                              },
                            }}
                          />
                  </TableCell>
                  {lastIndex === i+1 && status === "DISBURSAL" && addButtonEnabled && !enableMultiLoan && (
                    <TableCell className={classes.tableCellData}>
                      <>
                        <AddIcon
                          onClick={() => addData()}
                          style={{
                            color: "green",
                            cursor: "pointer",
                            marginTop: 20,
                          }}
                        />
            
                          <DeleteIcon
                            onClick={() => onClickDeleteData()}
                            style={{
                              color: "red",
                              cursor: "pointer",
                              marginTop: 20,
                            }}
                          />
                        
                      </>
                    </TableCell>
                  )}
                  </TableRow>
                  </>
                  ))}
          </TableBody>
        </Table>
      </TableContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} >
          <PDFExport
            ref={pdfExportComponent}
            paperSize="auto"
            margin={40}
            fileName={`Acknowledgement_Payment_${loanAccountNumber}.pdf`}
          >
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              // style={{ visibility: "hidden" }}
              style={{
                position: "absolute",
                left: "-1500px",
                top: 0,
              }}
            >
              <AcknowledgementPayment
                customerInfoData={{
                  loanAccountNumber: loanApplicationNumbedisbusalDetails,
                  paymentReferenceNum: paymentReferenceNumber,
                  disbursalAmount: cash,
                  paymentMode: "CASH",
                  disbursalDate: disbursalDates,
                  customerName:
                    applicantDetails && applicantDetails?.nameOnAdhaar,
                  transactionBranchName: paymentAcknowledgeBranchName,
                  imagelogo: logo,
                  maker: userDetails?.userName,
                  companyName:outletData?.domainNameFlag
                }}
              />
            </GridItem>
          </PDFExport>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem
          xs={12}
          sm={6}
          md={6}
          lg={6}
          style={{ textAlign: "start", marginTop: "20px" }}
        >
          {cash > 0 && cash <= PANCRITERIA && !disableSubmit > 0 && (
            <div style={{ display: "flex" }}>
              <Button
                round={false}
                className={classes.nextButton1}
                onClick={(event) => onClickData(event)}
                style={{ margin: "0px 10px" }}
              >
                <span>Generate</span>
              </Button>
              <FileUploadDisbursal
                addButtonProps={{
                  color: "info",
                  round: false,
                }}
                changeButtonProps={{
                  color: "info",
                  round: false,
                }}
                removeButtonProps={{
                  color: "danger",
                  round: false,
                }}
                removeFile={() => setFileUpload("")}
                sendFile={(file) => {
                  setFileUpload(file);
                }}
                ref={fileUploadComponent}
              />
            </div>
          )}
        </GridItem>
        <GridItem
          xs={12}
          sm={6}
          md={6}
          lg={6}
          style={{
            textAlign: window.innerWidth < 360 ? "center" : "right",
            marginTop: "10px",
          }}
        >
          <DisbursalSendBack
            loanApplicationId={loanApplicationId}
            classes={classes}
            callInProgress={callInProgress}
            setCallInProgress={setCallInProgress}
            toastUpdate={toastUpdate}
            featureFlags={featureFlags}
            navigateTo={"/loanservice/disbursal"}
          />
          <Button
            key={"btnB"}
            size="small"
            className={classes.nextButton1}
            disabled={callInProgress}
            onClick={() => onBack()}
          >
            Back
          </Button>
          <Button
            key={"btnP"}
            size="small"
            className={classes.nextButton}
            disabled={
              callInProgress ||
              calculatenetPayAble < 0 || 
              disableSubmit ||
              initiatorType === "CUSTOMER"
            }
            onClick={(event) => onUpload(event)}
          >
            Submit
          </Button>
        </GridItem>
      </GridContainer>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {showModal && (
        <OtpModal
          handleClose={handleClose}
          showModal={showModal}
          Otp={validateOtp}
          ResendOtp={resendOtp}
          message={msg}
          header={head}
          show={show}
        />
      )}
    </div>
  );
};

DisbursalRePledge.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  closeModal: PropTypes.func,
  loanApplicationId: PropTypes.number,
  loanApplicationNumber: PropTypes.object,
};

export default withStyles(goldRatesStyle)(DisbursalRePledge);
